<style lang="scss" src='./AlertFullDetails.scss' scoped></style>
<template src="./AlertFullDetails.html"></template>

<script>
  import AlertDetails from '@/views/alerts/components/alertList/alertDetails/AlertDetails.vue';
  import AlertMap from '@/views/alerts/components/alertList/alertMap/AlertMap.vue';

export default {
  name: "AlertFullDetails",
  props: {
    alert: {
      requierd: true,
    },
    showCreateTask: {
      requiered: true,
    }
  },
  data() {
    return {
    };
  },
  components: {
    AlertDetails,
    AlertMap,
  },
  

  watch: {
  },


  computed: {
  },

  methods: {
  },

  beforeCreate() {},

  created() {},

  mounted() {
  },
};
</script>
